import { extend, now } from './utils';
function animationFrame(callback) {
    window.requestAnimationFrame(callback);
}
export class Animation {
    constructor() {
        this._tickProxy = () => this._tick();
        this._started = false;
    }
    tick() { }
    done() { return false; }
    onEnd() { }
    onCancel() { }
    start() {
        if (!this.enabled()) {
            return;
        }
        if (!this.done()) {
            this._started = true;
            animationFrame(this._tickProxy);
        }
        else {
            this.onEnd();
        }
    }
    enabled() {
        return true;
    }
    cancel() {
        this._started = false;
        this.onCancel();
    }
    _tick() {
        if (!this._started) {
            return;
        }
        this.tick();
        if (!this.done()) {
            animationFrame(this._tickProxy);
        }
        else {
            this._started = false;
            this.onEnd();
        }
    }
}
export class Transition extends Animation {
    constructor(options) {
        super();
        extend(this, options);
    }
    done() {
        return this.timePassed() >= this.duration;
    }
    timePassed() {
        return Math.min(this.duration, now() - this.startDate);
    }
    moveTo(options) {
        const movable = this.movable;
        this.initial = movable[this.axis];
        this.delta = options.location - this.initial;
        this.duration = typeof options.duration === 'number' ? options.duration : 300;
        this.tick = this._easeProxy(options.ease);
        this.startDate = now();
        this.start();
    }
    _easeProxy(ease) {
        return function () {
            this.movable.moveAxis(this.axis, ease(this.timePassed(), this.initial, this.delta, this.duration));
        };
    }
    static easeOutExpo(t, b, c, d) {
        return t === d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
    }
}
